import React, { useCallback } from 'react';
import { useRequest } from 'ahooks';
import Panel from '@/components/Panel';
import { Area } from '@ant-design/charts';
import { GetWrongTimeServiceData } from '@/services/api';
import { Spin } from 'antd'
import ImgSource from '@/assets/img/jingying/shoururiqishi@2x.png'
import { chartDataFill } from '@/utils/chart'
export interface ParkingDailyIncomeProps {
  areaCode?: string;
}

const ParkingDailyIncome:React.FC<ParkingDailyIncomeProps> = ({areaCode}) => {
  const { data = [], loading, error } = useRequest(useCallback(() => {
    // return GetIncomeTrendDay(areaCode,'441800');
    return GetWrongTimeServiceData({areaCode});
  },[areaCode]), {
    formatResult: res => {
      const carCounts = res.data.map((item:any)=>{
        return {
          date:(item.showDay).split('-')[2],
          value:item.carCount,
          type:'车辆数量'
        }
      })
      const totalCounts = res.data.map((item:any)=>{
        return {
          date:(item.showDay).split('-')[2],
          value:item.totalCount,
          type:'服务次数'
        }
      })
      const totalDurationTimes = res.data.map((item:any)=>{
        return {
          date:(item.showDay).split('-')[2],
          value:item.totalDurationTime,
          type:'累计共享时长'
        }
      })
      return [...carCounts, ...totalCounts, ...totalDurationTimes]
    },
    refreshDeps: [areaCode]
  })
  
  // const fillData = chartDataFill(data, 'days', 'incomeTotal') // 数据填充
  const fillData = chartDataFill(data, 'dayStr', 'incomeTotal') // 数据填充

  if(loading) {
    return (
      <Panel title="错时服务">
        <div className="fetch_container" style={{ height: 200 }}>
          <Spin/>
        </div>
      </Panel>
    )
  }

  if(error) {
    return (
      <Panel title="错时服务">
        <div className="fetch_container" style={{ height: 200 }}>
          请求错误
        </div>
      </Panel>
    )
  }
  
  return (
    <Panel
      title="错时服务" 
    >
      {data?.length > 0 ?<Area
        height={200}
        padding={[20,20,23,48]}
        smooth={true}
        color={['#02E6CB','#315afa','#00a8fe']}
        data={data}
        xField="date"
        yField="value"
        seriesField="type"
        startOnZero={false}
        legend={false}
        line={{
          color:['#02E6CB','#315afa','#00a8fe'],
        }}
        xAxis={{
          // type: 'linear',
          label: {
            style: {
              fill: '#fff'
            }
          },
          line: {
            style: {
              stroke: '#12708D'
            }
          },
         
          // tickInterval: 1,
          range: [0, 1],
          tickLine: null
        }}
        yAxis={{
          label: {
            style: {
              fill: '#fff'
            },
            formatter: v => `${v}`,
          },
          line: {
            style: {
              stroke: '#12708D'
            }
          },
          grid: {
            line: {
              style: {
                stroke: '#12708D',
                strokeOpacity: 0.4
              }
            }
          },
          minTickInterval: 50,
          min: 0
        }}
        areaStyle={({type}: {type: '车辆数量' | '服务次数' | '累计共享时长'}) => {
          const colorMap = {
            '车辆数量': 'l(90) 0:rgba(2, 230, 203, 0.6) 1:rgba(2, 230, 203, 0.5)',
            '服务次数': 'l(90) 0:rgba(49, 89, 250, 0.6) 1:rgba(49, 89, 250, 0.5)',
            '累计共享时长': 'l(90) 0:rgba(0, 169, 254, 0.6) 1:rgba(0, 169, 254, 0.5)'
          };
          return {
            fill: colorMap[type]
          };
        }}
        tooltip={{
          formatter: (data) => {
            return {
              name: `${data.date} ${data.type}`,
              value: `${data.value}`
            }
          },
          showTitle: false
        }}
        animation={{
          appear: {
            animation: 'path-in',
            duration: 3000
          },
          enter: {
            easing: 'easeLinear',
            duration: 3000,
            delay:2000,
          }
          
        }}
       
      />
      :<div className="fetch_container" style={{ height: 200 }}>
      暂无数据
    </div>
    } 
    </Panel>
  )
}

export default ParkingDailyIncome;